import React from 'react';

const ChartUpIcon = () => {
    return (
        <svg
            width="24"
            height="36"
            viewBox="0 0 24 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.88281 24.1501V22.0801"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
            />
            <path
                d="M12 24.1498V20.0098"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
            />
            <path
                d="M17.1172 24.1497V17.9297"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
            />
            <path
                d="M17.1228 11.8496L16.6628 12.3896C14.1128 15.3696 10.6928 17.4796 6.88281 18.4296"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
            />
            <path
                d="M14.1875 11.8496H17.1175V14.7696"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9 28H15C20 28 22 26 22 21V15C22 10 20 8 15 8H9C4 8 2 10 2 15V21C2 26 4 28 9 28Z"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ChartUpIcon;
